export default __webpack_public_path__ + "static/media/Logo-clicOH.b2eb8da5.svg";